import { useCurrentMember } from '../useCurrentMember';
import { useLagoon } from '../useLagoon';

export const useCustomDisclaimerMessage = (key: string) => {
  const currentMember = useCurrentMember();
  const customDisclaimerData = useLagoon('custom-disclaimers')();
  const customDisclaimerMessage = customDisclaimerData?.find(
    (data) =>
      data?.dnt_pageName === key &&
      data?.active &&
      data?.policyId
        ?.split(',')
        ?.map((id) => id.trim())
        ?.includes(currentMember?.policyNumber)
  )?.message;

  return customDisclaimerMessage;
};
